module.exports = __webpack_public_path__ + "static/media/sagittarius.70f4e288.svg";